import React, {useEffect, useState} from "react";
import { useNavigate } from 'react-router-dom';
import { useForm, Controller  } from "react-hook-form";
import { useBaseUrlContext } from "../context/Base_url";
import { useAlertContext } from "../context/Alerts";
import SimpleBar from 'simplebar-react';
import axios from 'axios';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import { FilePond } from 'react-filepond';

import {ThemeProvider, Container, Typography,  FormControl, OutlinedInput, InputLabel, Collapse} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; 
import {ThemeCustom} from '../styles/Theme';
import 'simplebar-react/dist/simplebar.min.css';
import 'filepond/dist/filepond.min.css';

import ButtonImgMain from "../components/button/Button_img_main";
import ButtonImg from "../components/button/Button_img";
import FooterBar from "../components/navbar/Footer_bar";
import ModalAiJobCreate from "../components/Modal/Modal_ai_job_create";

import AddCircle from '../assets/add-circle.svg'
import Trash from '../assets/trash.svg'
import FolderAdd from '../assets/folder-add.svg'
import File from '../assets/document-text.svg'
import Close from '../assets/close-circle.svg'
import RefreshLight from '../assets/refresh-white.svg'
import WranIcon from '../assets/warn-icon-light.svg'

import loader from '../assets/tube-spinner.svg'
import AiIcon from '../assets/ai-generate.svg'
import LoadingIcon from '../assets/tube-spinner.svg'

const CalendarIcon = () => {
    return(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2V5" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 2V5" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.5 9.08997H20.5" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.6947 13.7H15.7037" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.6947 16.7H15.7037" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.9955 13.7H12.0045" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.9955 16.7H12.0045" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.29431 13.7H8.30329" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.29431 16.7H8.30329" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    )
}


const CreateJob = () => {

    const {register, handleSubmit, control, formState: { errors }, setValue} = useForm();
    const [criteria, setCriteria] = useState([])
    const [files, setFiles] = useState([]);
    const [closingDateValue, setClosingDateValue] = useState(null);
    const [criteriaErr, setCriteriaErr] = useState(false)
    const [jdProcess, setJdProcess] = useState(false)
    const [totalWeight, setTotalWeight] = useState(0)
    const [openFail, setOpenFail] = useState(false)
    const [openWarning, setOpenWarning] = useState(false)
    const [switchChecked, setSwitchChecked] = useState(false);
    const { baseUrl } = useBaseUrlContext();
    const { sucessAlert, failAlert } = useAlertContext();
    const navigate = useNavigate();
    const [aiGenerating, setAiGenerating] = useState(false)
    const [openAiJobCreate, setOpenAiJobCreate] = useState(false)

    // useEffect(()=>{console.log('date', value)},[value])
    // useEffect(()=>{console.log('file',files, files.at(0))},[files])
    // useEffect(()=>{console.log('criteria', criteria)},[criteria])

    //get total of weight

    useEffect(()=>{

        const sum = criteria.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);

        console.log('sum', sum);
        setTotalWeight(sum);

    },[criteria])

    //set weight count warning

    useEffect(()=>{

        if(totalWeight > 100){
            setOpenFail(true)
            setOpenWarning(false)
        }
        else if(totalWeight < 100){
            setOpenWarning(true)
            setOpenFail(false)
        }
        else{
            setOpenFail(false)
            setOpenWarning(false)
        }

    },[totalWeight])

    //criteria text array update

    const inputUpdate = (val, index) => {
        console.log('val',val, 'index',index)
        const criteriaUpdate = [...criteria]
        criteriaUpdate[index] = {'requirement':val, 'weight':criteriaUpdate[index].weight};
        setCriteria(criteriaUpdate);
    }

     //criteria weight array update

     const inputWeightUpdate = (val, index) => {
        console.log('val',val, 'index',index)
        const criteriaUpdate = [...criteria]
        const weight = val ? JSON.parse(val) : 1;
        criteriaUpdate[index] = {'requirement':criteriaUpdate[index].requirement, 'weight': weight};
        setCriteria(criteriaUpdate);
    }

    //add a new field

    const addNew = () => {
        setCriteria([...criteria, {'requirement':'', 'weight':1}]);
    }

    //delete new field

    const delField = (index) =>{
        const criteriaRemove = [...criteria]
        criteriaRemove.splice(index, 1);
        setCriteria(criteriaRemove)
    }

    //check if there're empty fields

    useEffect(()=>{
        if(criteriaErr){
            const emptyCriteria = criteria.filter(item => item.requirement.trim() === '')
            emptyCriteria.length > 0 ? setCriteriaErr(true) : setCriteriaErr(false)
        }
    },[criteria])

    //form submit

    const submit = (data) => {

        console.log('data',data, criteria)

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const dataObj = JSON.stringify({
            "title": data.title,
            "referenceId": data.referenceId,
            "closingDate": new Date(closingDateValue).getTime(),
            "department": data.department,
            "requirements": criteria,
            "mailAutomationEnabled": switchChecked,
        })

        axios
        .post(`${baseUrl}/job-descriptions`, dataObj, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 201){
                console.log('JobList', res.data)
                navigate('/job-board')
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //submit btn in footer

    const submitBtn = () => {
        console.log('submitBtn')
        const emptyCriteria = criteria.filter(item => item.requirement.trim() === '')
        emptyCriteria.length > 0 ||  criteria.length === 0  ? setCriteriaErr(true) : setCriteriaErr(false)
    }

    //cancel btn in footer

    const cancel = () => {
        console.log('cancel')
        navigate('/job-board')
    }

    //remove all requirements

    const deleteAll = () => {
        setCriteria([])        
    }

    //process file

    const processFile = () => {

        console.log('processFile',files)
        setJdProcess(true)

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type':'multipart/form-data'
        }

        const formData = new FormData()
        formData.append( "file", files[0].file)

        axios
        .post(`${baseUrl}/job-descriptions/upload`, formData, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('JobList', res.data)
                setCriteria([...res.data.requirements])
                setFiles([])
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
            setJdProcess(false)
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true, 'Oops! Something went wrong. Please hang tight and try again in a moment.')
            setJdProcess(false)
        })

    }


    //open AI job create

    const aiJobCreate = () => {
        setOpenAiJobCreate(true)
    }

    //const generate AI jd

    const generateJobApi = (data) => {

        console.log('generateWithAI')
        setAiGenerating(true)

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        axios
        .post(`${baseUrl}/job-descriptions/generateJobRequirements`, data, {headers:header})
        .then((response) => {
            console.log('res generateJobRequirements', response);
            const res = response.data;
            if(res.code === 200){
                sucessAlert(true, res.message)
                setCriteria(res.data.requirements)
                setValue('title', res.data.title)
                setOpenAiJobCreate(false)
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
            setAiGenerating(false)

        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
            setAiGenerating(false)
        })

    }

    return(
        <ThemeProvider theme={ThemeCustom}>
            <ModalAiJobCreate
                setOpenAiJobCreate={setOpenAiJobCreate}
                openAiJobCreate={openAiJobCreate}
                generateJobApi={generateJobApi}
                aiGenerating={aiGenerating}
            />
            <Container maxWidth="xl" className="mt-20 mb-5 pt-5">
                <form onSubmit={handleSubmit(data => submit(data))}>
                    <div className="mb-7 flex justify-between items-center relative">
                        <Typography variant="textheader2" component={'div'}>Create Job</Typography>
                        <ButtonImgMain 
                            variant='purple' 
                            type='button' 
                            disabled={false} 
                            name={'Create with AI'}
                            class='capitalize ai-btn min-w-[13rem]'
                            img={AiIcon}
                            posision={''}
                            onClick={aiJobCreate}
                        />
                        <div className="max-w-[calc(100%-14rem)] absolute right-0">
                            <Collapse in={totalWeight === 100 ||  totalWeight === 0 ? false : true }>
                                <div className={`${totalWeight < 100 ? 'bg-yellow' : 'bg-red'} rounded-xl flex items-center py-3 px-5 min-w-[30rem]`}>
                                    <img src={WranIcon} alt="warn icon" className="w-5 mr-3"/> 
                                    <div className="text-white text-base">
                                        Oops! Your sum of weights is<span className="font-semibold pl-1">{totalWeight}</span>. Let's aim for a perfect 100. Please adjust.
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className='rounded-xl mb-5 bg-white p-5'>
                        <SimpleBar className="create-job-height rounded-xl p-0 m-0">
                            <div>
                                <Typography component={'div'} variant="textheader3" className="mb-5">Job Details</Typography>
                                <Grid container columnSpacing={3} >
                                    <Grid md={4} xs="auto" className={'px-3'}>
                                        <div>
                                            <FormControl fullWidth variant="standard">
                                                <div className="flex justify-between">
                                                    <InputLabel shrink htmlFor="jobTitle">Job Title</InputLabel>
                                                    {errors.title && <span className="text-red font-medium text-sm">Job title is required</span>}
                                                </div>
                                                <OutlinedInput
                                                    id="jobTitle"
                                                    placeholder="Head of Sales"
                                                    type='text'
                                                    {...register("title", { required:true} )}
                                                />
                                            </FormControl>
                                            <FormControl fullWidth variant="standard">
                                                <div className="flex justify-between">
                                                    <InputLabel shrink htmlFor="ref">Reference Number</InputLabel>
                                                    {errors.referenceId && <span className="text-red font-medium text-sm">Reference number is required</span>}
                                                </div>
                                                <OutlinedInput
                                                    id="ref"
                                                    placeholder="HOS45721"
                                                    type='text'
                                                    {...register("referenceId", { required:true} )}
                                                />
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid md={4} xs="auto">
                                        <div>
                                            <FormControl fullWidth variant="standard">
                                                <div className="flex justify-between">
                                                    <InputLabel shrink htmlFor="jobDepart">Department</InputLabel>
                                                    {errors.department && <span className="text-red font-medium text-sm">Department is required</span>}
                                                </div>
                                                <OutlinedInput
                                                    id="jobDepart"
                                                    placeholder="Sales"
                                                    type='text'
                                                    {...register("department", { required:true} )}
                                                />
                                            </FormControl>
                                            <FormControl fullWidth variant="standard">
                                                <div className="flex justify-between">
                                                    <InputLabel shrink htmlFor="closingDate">Closing Date</InputLabel>
                                                    {errors.closingDate && <span className="text-red font-medium text-sm">Closing date is required</span>}
                                                </div>
                                               <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <Controller
                                                        name="closingDate"
                                                        control={control}
                                                        rules={{ required: closingDateValue !== null?false:true }}
                                                        defaultValue={null}
                                                        credits={false}
                                                        render={({ field }) => (
                                                            <DatePicker 
                                                                id="closingDate"
                                                                value={field.value} 
                                                                minDate={moment()}
                                                                slots={{
                                                                    openPickerIcon: CalendarIcon,
                                                                }}    
                                                                onChange={(newValue) => setClosingDateValue(newValue)}  
                                                            />  
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid md={4} xs="auto" className='pb-7 filepond-custom'>
                                        {
                                            files.length === 0 ? (
                                                <FilePond
                                                    files={files}
                                                    onupdatefiles={setFiles}
                                                    allowMultiple={false}
                                                    maxFiles={1}
                                                    name="files"
                                                    className={'fileUpload'}
                                                    labelIdle={
                                                        `<div class="w-full border border-dashed border-cultured bg-culturedLight p-4 rounded-md min-h-full flex flex-col justify-center items-center"><img src=${FolderAdd} alt="flie add" class="w-10"/><div class="text-primary text-sm font-sans font-medium my-4 text-center">Drag your job advert file here. or <span class="filepond--label-action font-semibold">Browse</span> to automaticaly populate your job requirements</div></div>`
                                                    }
                                                    credits={false}
                                                />
                                            ):(
                                                <div className=" w-full border border-solid border-cultured p-4 rounded-xl flex min-h-full h-full ">
                                                    <div className="w-full relative border border-dashed border-cultured bg-culturedLight p-4 rounded-md min-h-full flex flex-col justify-center items-center">
                                                        <div className="">
                                                            <img src={Close} alt="close" className="w-6 absolute right-3 top-3 cursor-pointer" onClick={()=>setFiles([])}/>
                                                        </div>
                                                        <img src={File} alt="flie add" className="w-10"/>
                                                        <div className="text-primary break-words max-w-[80%] truncate text-sm font-sans font-medium mt-4 text-center">{files.at(0).file.name}
                                                        </div>
                                                        <ButtonImgMain 
                                                            variant='green' 
                                                            type='button' 
                                                            disabled={false} 
                                                            name='Auto Populate'
                                                            class='capitalize mt-4'
                                                            img={jdProcess ? loader : RefreshLight}
                                                            onClick={processFile}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        }
                                        
                                    </Grid>
                                </Grid>
                                <div>
                                    <div className="flex justify-between items-end my-5">
                                        <Typography component={'div'} variant="textheader3" >Job Requirements</Typography>
                                        {criteria.length > 1 ?(
                                            <Typography component={'div'} className="cursor-pointer flex items-center underline hover:text-gray" align="right" variant="textBase" onClick={deleteAll}>
                                                <img src={Close} alt="close" className="w-5 cursor-pointer mr-2"/>
                                                Clear All
                                            </Typography>
                                            ):''
                                        }
                                    </div>
                                    {criteria.length > 0 && criteria.map((item, index)=>(
                                        <FormControl key={index} fullWidth variant="standard">
                                            <div className="flex items-center">
                                                <OutlinedInput
                                                    id={`jobReq${index}`}
                                                    placeholder="Enter job requirements"
                                                    type='text'
                                                    value={item.requirement}
                                                    // readOnly={item !== '' ?true:false}
                                                    // className={item !== '' ? 'cursor-default-input':''}
                                                    // endAdornment={
                                                    //     <InputAdornment position="end">
                                                    //         <img src={ExportAi} alt="ai genarated" className="w-[1.5rem]"/>
                                                    //     </InputAdornment>
                                                    // }
                                                    {...register(`jobReq${index}`, {
                                                        required: item === '' ? true : false
                                                    })}
                                                    onChange={(e) => inputUpdate(e.target.value, index)}
                                                />
                                                <div className="pl-4 max-w-[6rem] w-full">
                                                    <OutlinedInput
                                                        id={`jobWeigth${index}`}
                                                        placeholder="0"
                                                        type='number'
                                                        min={1}
                                                        max={100}
                                                        value={item.weight}
                                                        // readOnly={item !== '' ?true:false}
                                                        // className={item !== '' ? 'cursor-default-input':''}
                                                        // endAdornment={
                                                        //     <InputAdornment position="end">
                                                        //         <img src={ExportAi} alt="ai genarated" className="w-[1.5rem]"/>
                                                        //     </InputAdornment>
                                                        // }
                                                        {...register(`jobWeigth${index}`, {
                                                            required: item === '' ? true : false
                                                        })}
                                                        onChange={(e) => inputWeightUpdate(e.target.value, index)}
                                                    />
                                                </div>
                                                <div className="ml-3 flex">
                                                    {/* <ButtonImg 
                                                        variant='culturedIconButton' 
                                                        type='button' 
                                                        disabled={item !== '' ?false:true} 
                                                        class='min-w-[auto]'
                                                        img={item !== '' ?Edit:EditDisable}
                                                    /> */}
                                                    <ButtonImg 
                                                        variant='redIconButton' 
                                                        type='button' 
                                                        disabled={false} 
                                                        name=''
                                                        class='min-w-[auto]'
                                                        img={Trash}
                                                        onClick={()=>delField(index)}
                                                    />
                                                </div>
                                            </div>
                                        </FormControl>
                                    ))}
                                    {criteriaErr ? (<div className="text-red font-medium text-sm mb-4">Job requirement fields can not be empty</div>):''}
                                    <div className="req-add-wrapper">
                                        <Grid container columnSpacing={3} >
                                            <Grid xs className={'px-3'}>
                                                <ButtonImgMain 
                                                    variant='culturedLight' 
                                                    type='button' 
                                                    disabled={false} 
                                                    name='Add New'
                                                    class='capitalize w-full '
                                                    img={AddCircle}
                                                    onClick={addNew}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </SimpleBar>
                    </div>
                    <FooterBar
                        submitBtn={submitBtn}
                        cancel={cancel}
                        btnOutline={'Cancel'}
                        disabledSecondary={totalWeight === 100 ? false : true}
                        autoEmail={true}
                        switchChecked={switchChecked}
                        setSwitchChecked={setSwitchChecked}
                    />
                </form>
            </Container>
        </ThemeProvider>
        
    )
}

export default CreateJob;